<template>
  <div class="overflow-auto">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'CatalogPage',
  components: {},
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      tabIndex: 0,
    };
  },
  computed: {},
  methods: {
    onTabClick(tab, event) {
      this.tabIndex = tab.index;

      if (this.tabIndex === 0) {
        this.$router.push();
      }
    },
    setTab(tabIndex) {},
  },
};
</script>

<style scoped></style>
